import React, { Component } from 'react';
import classNames from 'classnames';

import withStyles from '@material-ui/core/styles/withStyles';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Paper from '@material-ui/core/Paper';
import Grow from '@material-ui/core/Grow';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import Tooltip from '@material-ui/core/Tooltip';
import Button from 'components/CustomButtons/Button.js';

const style = {
  popperClose: {
    pointerEvents: 'none',
    display: 'none !important',
	},
	tooltip: {
		zIndex: '1201',
	},
  popperResponsive: {
    zIndex: '1200',
	},
	rightButton: {
		float: 'right',
	},
	grow: {
		transformOrigin: '0 0 0',
	},
};

class ActionButtons extends Component {
	state = {
		openActions: null,
	};

	handleClickActions = (event) => {
		if (this.state.openActions && this.state.openActions.contains(event.target)) {
			this.setState({ openActions: null });
		} else {
			this.setState({ openActions: event.currentTarget });
		}
	}

	handleCloseActions = () => {
		this.setState({ openActions: null });
	}

	handleMenuItemClick = (callback) => {
		this.handleCloseActions();
		if (callback) {
			callback();
		}
	}

	render() {
		const { items = [], classes } = this.props;
		if (items.length === 0) {
			return null;
		}
		return (
			<>
				<Button
					color="transparent"
					justIcon
					onClick={this.handleClickActions}
					className={classes.rightButton}
					aria-owns={this.state.openActions ? 'actions-menu-list' : null}
					aria-haspopup="true"
					aria-label="Actions"
				>
					<MoreVertIcon />
				</Button>
				<Popper
					open={Boolean(this.state.openActions)}
					anchorEl={this.state.openActions}
					transition
					disablePortal
					placement="bottom-end"
					className={classNames({
						[classes.popperClose]: !this.state.openActions,
						[classes.popperResponsive]: true,
					})}
				>
					{({ TransitionProps }) => (
						<Grow
							{...TransitionProps}
							id="actions-menu-list"
							className={classes.grow}
						>
							<Paper className={classes.dropdown}>
								<ClickAwayListener onClickAway={this.handleCloseActions}>
									<MenuList role="menu">
										{items.map((item, index) => {
											return (
												<Tooltip
													className={classes.tooltip}
													key={index}
													arrow
													title={this.state.openActions ? (item.tooltip || '') : ''}
												>
													<div>
														<MenuItem
															disabled={item.disabled}
															onClick={() => { this.handleMenuItemClick(item.fn) }}
														>
															{item.label}
														</MenuItem>
													</div>
												</Tooltip>
											)
										})}
									</MenuList>
								</ClickAwayListener>
							</Paper>
						</Grow>
					)}
				</Popper>
			</>
		);
	}
}

export default withStyles(style)(ActionButtons);
